import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const PASSWORD_MIN_LENGTH = 7

export const useAddUserValidationSchema = () => {
	const { t } = useTranslation()

	const addUserValidationSchema = yup.object({
		email: yup.string().email().required(t('Email is required')),
		password: yup
			.string()
			.min(
				PASSWORD_MIN_LENGTH,
				t('Password is too short - should be {{ count }} chars minimum.', {
					count: PASSWORD_MIN_LENGTH
				})
			)
			.required(t('Password is required')),
		password2: yup
			.string()
			.oneOf([yup.ref('password'), undefined], t('Passwords must match'))
			.required(t('Confirm password is required'))
	})

	return yupResolver(addUserValidationSchema)
}
